"use strict";
/**
 *
 * FormMaskedField/textMask
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
const text_mask_core_1 = require("text-mask-core");
exports.CARET_TRAP = '[]';
function createTextMaskInput(props) {
    return text_mask_core_1.createTextMaskInputElement(props);
}
exports.createTextMaskInput = createTextMaskInput;
function conformToMask(maskOrFunc, value, props) {
    return text_mask_core_1.conformToMask(value, maskOrFunc, props).conformedValue;
}
exports.conformToMask = conformToMask;
function unmask(maskOrFunc, value, decimalSymbol) {
    const mask = (typeof maskOrFunc === 'function' ? maskOrFunc(value) : maskOrFunc).filter((part) => part !== exports.CARET_TRAP);
    let unmaskedValue = '';
    let char, part;
    for (let i = 0; i < value.length; i++) {
        char = value[i];
        part = mask[i];
        if (part instanceof RegExp) {
            const matched = char.match(part);
            if (matched) {
                unmaskedValue = unmaskedValue + matched[0];
            }
        }
        else if (decimalSymbol && part === decimalSymbol) {
            unmaskedValue = unmaskedValue + '.';
        }
    }
    return unmaskedValue;
}
exports.unmask = unmask;
